import { render, staticRenderFns } from "./compChoose.vue?vue&type=template&id=1afe8e80&scoped=true&"
import script from "./compChoose.vue?vue&type=script&lang=js&"
export * from "./compChoose.vue?vue&type=script&lang=js&"
import style0 from "./compChoose.vue?vue&type=style&index=0&id=1afe8e80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afe8e80",
  null
  
)

export default component.exports